import { IBaseAuthProvider } from "./base-auth-provider";

export class FacebookProvider implements IBaseAuthProvider {

    loadProvider(): Promise<void> {
        return new Promise<void>((resolve) => {
            window["fbAsyncInit"] = () => {
                window["FB"].init({
                    appId: window["facebookAppId"],
                    cookie: true,
                    status: true, // check login status  
                    xfbml: true,
                    version: 'v2.12'
                });
                resolve();
            };

            (function (d, s, id) {
                const fjs = d.getElementsByTagName(s)[0] || document.head;
                if (d.getElementById(id)) {
                    resolve();
                    return;
                }
                const js = d.createElement(s) as HTMLScriptElement;
                js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js";
                if (fjs && fjs.parentNode) {
                    fjs.parentNode.insertBefore(js, fjs);
                }
            }(document, 'script', 'facebook-jssdk'));
        });
    }

    redirectToLogin() { }

    // Here we run a very simple test of the Graph API after login is
    // successful.  See statusChangeCallback() for when this call is made.
    fetchUserDetails(): Promise<{ firstName: string, lastName: string, email: string, picture: string }> {
        return new Promise<{ firstName: string, lastName: string, email: string, picture: string }>((resolve) => {
            window["FB"].api('/me', { fields: "first_name,last_name,email,picture" }, (response) => {
                resolve({ firstName: response.first_name, lastName: response.last_name, email: response.email, picture: response.picture && response.picture.data ? response.picture.data.url : null });
            });
        });
    }

    //Facebook Login
    getAuthToken(callback: (response: { accessToken: string, userId: string, subProviderName: string, metadata: string, doNotSaveUserLogin: boolean }) => void): void {
        window["FB"].login((response) => {
            if (response.status === 'connected') {
                const accessToken = response.authResponse.accessToken;
                const userId = response.authResponse.userID;
                // Logged into your app and Facebook.
                callback({ accessToken, userId, subProviderName: null, metadata: null, doNotSaveUserLogin: false });
            } else {
                callback(null);
            }
        }, { scope: 'public_profile,email' });
    }

    logout(): Promise<any> {
        return new Promise<void>((resolve) => {
            window["FB"].getLoginStatus(() => {
                window["FB"].logout((response) => {
                    resolve(response);
                });
            });
        });
    }
}
